import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '../services/api'

export default function Register() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      await api.post('/auth/register', { email, password, name })
      navigate('/verify', { state: { email } })
    } catch (err: any) {
      setError(err.response?.data?.error || t('register.error'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor:'#f8f9fa',padding:20}}>
      <div style={{backgroundColor:'#fff',borderRadius:20,padding:40,width:'100%',maxWidth:400,boxShadow:'0 4px 24px rgba(0,0,0,0.06)'}}>
        <div style={{display:'flex',justifyContent:'flex-end',marginBottom:16}}>
        </div>
        <div style={{textAlign:'center'}}>
          <img src="/favicon.svg" alt="Vigilant" style={{width:64,height:64}} />
        </div>
        <h1 style={{fontSize:28,fontWeight:600,textAlign:'center',margin:'8px 0 4px',color:'#1a1a1a'}}>Vigilant</h1>
        <p style={{fontSize:15,textAlign:'center',color:'#888',marginBottom:32}}>{t('register.subtitle')}</p>
        <form onSubmit={handleRegister} style={{display:'flex',flexDirection:'column',gap:12}}>
          {error && <div style={{backgroundColor:'#fff0f0',color:'#e74c3c',padding:'12px 16px',borderRadius:10,fontSize:14}}>{error}</div>}
          <input style={{padding:'14px 16px',borderRadius:12,border:'1px solid #e0e0e0',fontSize:16,outline:'none'}} type="text" placeholder={t('common.name')} value={name} onChange={e => setName(e.target.value)} required />
          <input style={{padding:'14px 16px',borderRadius:12,border:'1px solid #e0e0e0',fontSize:16,outline:'none'}} type="email" placeholder={t('common.email')} value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={{padding:'14px 16px',borderRadius:12,border:'1px solid #e0e0e0',fontSize:16,outline:'none'}} type="password" placeholder={t('common.password')} value={password} onChange={e => setPassword(e.target.value)} required />
          <button style={{padding:14,borderRadius:12,border:'none',backgroundColor:'#2D7A3A',color:'#fff',fontSize:16,fontWeight:600,cursor:'pointer',marginTop:8}} type="submit" disabled={loading}>
            {loading ? t('register.loading') : t('register.submit')}
          </button>
        </form>
        <p style={{textAlign:'center',marginTop:24,color:'#888',fontSize:15}}>
          {t('register.hasAccount')} <Link to="/login" style={{color:'#2D7A3A',textDecoration:'none',fontWeight:500}}>{t('register.login')}</Link>
        </p>
      </div>
    </div>
  )
}
